import useValueChangeListener from "../../../../services/state/general/useValueChangeListener";
import useAuthRequest from "../../../../services/state/request/useAuthRequest";
import {request} from "../../../../../res/rest/restRequest";
import {env} from "../../../../../res/config/env";
import HttpClient from "../../../../services/http/HttpClient";
import {api} from "../../../../../res/rest/api";
import {silentRefresh} from "../../../../../redux/action/cartActions";
import {useDispatch} from "react-redux";
import useSession from "../../../../services/state/session/useSession";

const useSurcharge = (orderID, surchargeRate, overpayment) => {

    const dispatch = useDispatch();
    const { sessionData : session } = useSession();

    const {
        loading,
        sendIt,
    } = useAuthRequest();

    const refresh = () => {
        dispatch(silentRefresh({session}));
    }

    const updateSurcharge = () => {
        const req = request.process("updatecreditcardsurcharge")
            .param("c_order_ID", orderID)
            .param("rate", surchargeRate)
            .param("overpayment", overpayment)

        const url = req.buildRequest(env.API_URL);
        const runProc = (session) => HttpClient.client.post(url, req.buildRequestBody(), api.auth(session))

        sendIt(runProc, refresh);
    }

    useValueChangeListener(updateSurcharge, [surchargeRate, overpayment], [surchargeRate])

    return {
        loading
    }
}

export default useSurcharge;